import './utils/sharedDeviceBoot'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './index.css'

// Unregister ALL service workers - no more PWA for now
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      {/* The app's only Toaster. Top center keeps toasts clear of the
          shared-device bar at the bottom of the screen. */}
      <Toaster
        position="top-center"
        gutter={8}
        containerStyle={{ top: 16, left: 16, right: 16 }}
        toastOptions={{
          duration: 4000,
          style: { fontSize: '16px', maxWidth: 'min(90vw, 480px)' },
          error: { duration: 6000 },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)
